import saudicupApi from "@/api/saudicupApi";
import authHeader from "@/services/saudi-cup/auth/auth-header";
const END_POINT = "api";
class GuestService {
    guest_by_encrypted_id(guest_id) {
        return saudicupApi.get(
            `${END_POINT}/current-guest-encrypted/${guest_id}`, { headers: authHeader() }
        ).then((response) => {
            return response;
        });
    }
    check_guest_exists(registration_number) {
        return saudicupApi.get(
            `${END_POINT}/show-guest/${registration_number}`, { headers: authHeader() }
        ).then((response) => {
            return response;
        });
    }
    get_guest_package(registration_number) {
        return saudicupApi.get(
            `${END_POINT}/guest-package/${registration_number}`, { headers: authHeader() }
        ).then((response) => {
            return response;
        });
    }
    confirm_guest_package(body) {
        return saudicupApi.post(
            `${END_POINT}/confirm-guest-package`, body, { headers: authHeader() }
        ).then((response) => {
            return response;
        });
    }
    send_hotel_details(body) {
        return saudicupApi.post(
            `${END_POINT}/guest/store-hotel-booking`, body, { headers: authHeader() }
        ).then((response) => {
            return response;
        });
    }
}
export default new GuestService();